import { WORKER_OUTCOME_RESULT, type WorkerOutcomeResult } from "../../api/useUpdateInterview";
import { type FeedbackStep } from "./feedbackStep";

export interface FreeTextContext {
  result: WorkerOutcomeResult;
  textFieldHeading: string;
  textFieldPlaceholder?: string;
  parentStep: FeedbackStep;
  confirmationStep: FeedbackStep;
}

interface OptionItem {
  label: string;
  value: WorkerOutcomeResult;
  textFieldHeading?: string;
  textFieldPlaceholder?: string;
}

export const GOT_OFFER_SUB_OPTIONS: OptionItem[] = [
  {
    label: "Yes, I know the next steps",
    value: WORKER_OUTCOME_RESULT.gotOfferKnowNextSteps,
  },
  {
    label: "They said they'd follow up",
    value: WORKER_OUTCOME_RESULT.gotOfferFollowUpNextSteps,
  },
  {
    label: "No, they didn't explain next steps",
    value: WORKER_OUTCOME_RESULT.gotOfferNoNextSteps,
  },
];

export const NOT_HEARD_BACK_SUB_OPTIONS: OptionItem[] = [
  {
    label: "In a few days or less",
    value: WORKER_OUTCOME_RESULT.notHeardBackFewDays,
  },
  {
    label: "Within a week",
    value: WORKER_OUTCOME_RESULT.notHeardBackWithinWeek,
  },
  {
    label: "They didn't specify",
    value: WORKER_OUTCOME_RESULT.notHeardBackNotSpecified,
  },
];

export const NOT_OFFERED_ROLE_OPTIONS: OptionItem[] = [
  {
    label: "Schedule misalignment",
    value: WORKER_OUTCOME_RESULT.scheduleMisalignment,
  },
  {
    label: "Pay misalignment",
    value: WORKER_OUTCOME_RESULT.payMisalignment,
  },
  {
    label: "Not enough experience",
    value: WORKER_OUTCOME_RESULT.notEnoughExperience,
  },
  {
    label: "They didn't give a reason",
    value: WORKER_OUTCOME_RESULT.notSure,
  },
  {
    label: "Other",
    value: WORKER_OUTCOME_RESULT.notOfferTheRoleOther,
    textFieldHeading: "Share more details (Optional)",
  },
];

export const NOT_INTERVIEW_OPTIONS: OptionItem[] = [
  {
    label: "They are no longer hiring",
    value: WORKER_OUTCOME_RESULT.noLongerHiring,
  },
  {
    label: "Interviewer unavailable",
    value: WORKER_OUTCOME_RESULT.interviewNotAvailable,
  },

  {
    label: "Other",
    value: WORKER_OUTCOME_RESULT.notInterviewOther,
    textFieldHeading: "Please share why you didn't interview (Optional)",
    textFieldPlaceholder: "Example: I got there too late and was turned away",
  },
];
